<template>
  <div class="meeting-sign" :class="{ 'no-scroll': isMobile, bgColor: !isMobile }">
    <div class="meeting-header" :class="{ 'meeting-title': !isMobile }">
      会议报名
    </div>
    <ul class="meeting-body" v-if="isMobile">
      <li class="meeting-name">
        <span class="title">会议名称</span>
        <span>{{ meetingObj.meetingTitle }}</span>
      </li>
      <li>
        <span class="title">报名开始时间</span>
        <span>{{ meetingObj.signUpBeginTime }}</span>
      </li>
      <li>
        <span class="title">报名结束时间</span>
        <span>{{ meetingObj.signUpEndTime }}</span>
      </li>
      <li>
        <span class="title">会议开始时间</span>
        <span>{{ meetingObj.meetingBeginTime }}</span>
      </li>
      <li>
        <span class="title">会议结束时间</span>
        <span>{{ meetingObj.meetingEndTime }}</span>
      </li>
      <li :class="{ 'meeting-intro': meetingObj.meetingDesc }">
        <span class="title">会议说明</span>
        <span style="white-space:pre-line;line-height:1.2em;">{{
            meetingObj.meetingDesc ? meetingObj.meetingDesc : "————"
        }}</span>
      </li>
    </ul>
    <el-form label-width="180px" class="meeting-form" :model="model" ref="baseForm" v-if="!isMobile">
      <div class="sign-header">会议信息</div>
      <el-row :gutter="20" :class="{ 'sign-row': !isMobile }">
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="会议名称：">
            <span>{{ model.meetingTitle }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="生成时间：">
            <span>{{ model.createTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="报名开始时间：">
            <span>{{ model.signUpBeginTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="报名结束时间：">
            <span>{{ model.signUpEndTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="会议开始时间：">
            <span>{{ model.meetingBeginTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="会议结束时间：">
            <span>{{ model.meetingEndTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="报名二维码：">
            <img :src="model.qrcodeUrl" data-preview="true" style="width: 80px;height: 80px;" />
          </el-form-item>
        </el-col>
        <el-col :lg="24">
          <el-form-item label="会议说明：">
            <span style="white-space:pre-wrap;" v-if="model.meetingDesc">{{
                model.meetingDesc
            }}</span>
            <span v-else>————</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="model.meetingStatus === 1" class="sign-header">报名信息</div>
      <el-row v-if="model.meetingStatus == 1" :gutter="20" :class="{ 'sign-row': !isMobile }">
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="单位名称：" :rules="[
            { required: true, message: '请输入单位名称', trigger: 'blur' }
          ]" prop="orgName">
            <el-input placeholder="请输入单位名称" :disabled="isDisabled" v-model.trim="model.orgName"
              :maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="报名人姓名：" :rules="[
            { required: true, message: '请输入报名人姓名', trigger: 'blur' }
          ]" prop="signerName">
            <el-input placeholder="请输入报名人姓名" :disabled="isDisabled" v-model.trim="model.signerName"
              :maxlength="15"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs" v-if="model.hasSignerPositionName == 1">
          <el-form-item label="职务：" :rules="[
            { required: true, message: '请输入职务', trigger: 'blur' }
          ]" prop="positionName">
            <el-input placeholder="请输入职务" :disabled="isDisabled" v-model.trim="model.positionName"
              :maxlength="25"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs" v-if="model.hasOfficePhone == 1">
          <el-form-item label="电话：" :rules="[
            { required: true, message: '请输入电话', trigger: 'blur' }
          ]" prop="officePhone">
            <el-input placeholder="请输入电话" :disabled="isDisabled" @blur="mobileValid($event)"
              v-model.trim="model.officePhone" :maxlength="25"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="手机号：" :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' }
          ]" prop="mobile">
            <el-input placeholder="请输入手机号" :disabled="isDisabled" @blur="mobileValid($event)"
              v-model.trim="model.mobile" :maxlength="11"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <el-form-item label="验证码：" :rules="[
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]" prop="verCode">
            <div class="ver-code">
              <el-input placeholder="请输入验证码" :disabled="isDisabled" v-model="model.verCode"></el-input>
              <el-button type="primary" :disabled="isDisabled" class="code-btn" @click="sendCode">点击获取</el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :lg="colLg" :xs="colXs">
          <div class="flexS">
            <el-form-item label="参会人数：" :rules="[
              { required: true, validator: this.validateLimitPeople, trigger: 'blur' }
            ]" prop="signCount">
              <el-input style="width:100%" placeholder="请输入参会人数" v-model.trim="model.signCount"
                :maxlength="11"></el-input>
            </el-form-item>
            <span class="tips">（本次活动每人每次可报名{{ model.limitPeople }}人）</span>
          </div>
        </el-col>
        <el-col :lg="colLg" :xs="colXs" v-if="model.hasSignerInfo == 1">
          <el-form-item label="参会人信息：" :rules="[
            { required: true, message: '请输入参会人信息', trigger: 'blur' }
          ]" prop="signerInfo">
            <el-input show-word-limit type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入参会人信息"
              v-model="model.signerInfo" :maxlength="500"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="meeting-footer" v-if="model.meetingStatus === 1">
      <el-button type="primary" class="next-btn" v-if="isMobile" @click="
        $router.replace({
          name: 'SubmitPage',
          params: { hasOfficePhone: model.hasOfficePhone,hasSignerPositionName:model.hasSignerPositionName,hasSignerInfo:model.hasSignerInfo,meetingDesc:meetingObj.meetingDesc }
        })
      ">下一步</el-button>
      <el-button type="primary" class="submit-btn" :loading="loading" :disabled="isDisabled" v-if="!isMobile"
        @click="submitMeeting">提交</el-button>
    </div>
    <!-- PC 弹框 -->
    <el-dialog title="提示" v-if="!isMobile" :visible.sync="tipVisible" :width="isMobile ? '80%' : '30%'" :center="true">
      <span>{{ getTipTxt }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- moblie 弹窗 -->
    <div v-else-if="tipVisible" class="backDiv">
      <div class="dialog-box">
        <div class="dialog-box_title">
          提示
        </div>
        <div class="dialog-box_content">
          {{ getTipTxt }}
        </div>
        <div class="dialog-box_Btn" @click="tipVisible = false">
          确 认
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sign",
  data() {
    return {
      meetingId: "",
      meetingObj: {
        meetingStatus: "",
        meetingTitle: "",
        signUpBeginTime: "",
        signUpEndTime: "",
        meetingBeginTime: "",
        meetingEndTime: "",
        meetingDesc: ""
      },
      colLg: { span: 8, offset: 0 },
      colXs: { span: 12, offset: 0 },
      model: {
        signCount: '',
        limitPeople: null,
        signerInfo: '',
        meetingStatus: "",
        meetingTitle: "",
        createTime: "",
        signUpBeginTime: "",
        signUpEndTime: "",
        meetingBeginTime: "",
        meetingEndTime: "",
        qrcodeUrl: "",
        meetingDesc: "",
        hasOrgName: "",
        hasSignerName: "",
        hasSignerPositionName: "",
        hasOfficePhone: "",
        hasSignerMobile: "",
        orgName: "",
        signerName: "",
        positionName: "",
        officePhone: "",
        mobile: "",
        verCode: ""
      },
      loading: false,
      isMobile: false,
      getTipTxt:
        "为了避免虚假报名，本次会议活动需要验证手机号码。请验证报名人手机号码后，再提交报名信息。",
      tipVisible: true,
      timer: null,
      isDisabled: false
    };
  },
  methods: {
    validateLimitPeople(rule, value, callback) {
      let reg = /^[+]{0,1}(\d+)$/g;
      if (value === '') {
        callback(new Error('请输入参会人数'));
      } else if (value == 0) {
        callback(new Error('参会人数不能为0'));
      } else if (value > this.model.limitPeople) {
        callback(new Error('参会人数不能超过每人每次可报名数'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入1到20的整数'));
      } else if (value > 20) {
        callback(new Error('参会人数不能超过20'));
      } else {
        callback();
      }
    },
    getMeetingData() {
      this.$http
        .get("/gdjx/pc/crm/meeting/sign/detail?meetingId=" + this.meetingId)
        .then(res => {
          if (res.data.success) {
            this.model = res.data.data;
            this.meetingObj = res.data.data;
            if (this.isMobile) {
              if (this.model.meetingStatus === 0) {
                this.getTipTxt = "会议未开始报名";
              } else if (this.model.meetingStatus === 2) {
                this.getTipTxt = "会议报名已过期";
              }
            } else {
              if (this.model.meetingStatus === 0) {
                this.$confirm("会议报名时间未开始", "提示");
              } else if (this.model.meetingStatus === 2) {
                this.$confirm("会议报名已结束", "提示");
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    mobileValid(e) {
      if (!/^[0-9]+\d$/.test(e.target.value)) {
        this.$message.warning("请输入数字");
      }
    },
    phoneValid(e) {
      if (!/^1[3456789]\d{9}$/.test(e.target.value)) {
        this.$message.warning("请输入正确的手机号码");
      }
    },
    sendCode() {
      if (!this.model.mobile) {
        this.$message.warning("手机不能为空");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.model.mobile)) {
        this.$message.warning("请输入正确的手机号码");
        return;
      }
      let params = {
        mobile: this.model.mobile
      };
      this.$http.post("/gdjx/pc/crm/meeting/sms/send", params).then(res => {
        if (res.data && res.data.data) {
          this.$message.success(res.data.data.msg);
        }
      });
    },
    submitMeeting() {
      this.model.meetingId = this.meetingId;
      this.$refs.baseForm.validate(v => {
        if (v) {
          this.$http
            .get(
              "/gdjx/pc/crm/meeting/sign/check?mobile=" +
              this.model.mobile +
              "&meetingId=" +
              this.meetingId
            )
            .then(res => {
              if (res.data.success) {
                if (res.data.data.hasSign) {
                  this.$message.warning("您已经报过名了");
                } else {
                  this.loading = true;
                  this.$http
                    .post("/gdjx/pc/crm/meeting/sign/commit", this.model)
                    .then(res => {
                      if (res.data.success) {
                        this.isDisabled = true;
                        this.$message.success(res.data.data.msg);
                      } else {
                        this.$message.warning(res.data.msg);
                      }
                      this.loading = false;
                    })
                    .catch(() => {
                      this.loading = false;
                      this.$message.error("报名失败");
                    });
                }
              }
            });
        } else {
          this.$message.warning("信息填写不完整，请填写完善后提交！");
        }
      });
    }
  },
  created() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    flag === null ? (this.isMobile = false) : (this.isMobile = true);
    let meetingId = this.$route.params.meetingId
      ? this.$route.params.meetingId
      : this.$route.query.meetingId;
    if (meetingId) {
      localStorage.setItem("meetingId", meetingId);
    }
    if (!meetingId) {
      meetingId = localStorage.getItem("meetingId");
    }
    if (!this.$route.params.init) {
      this.$router.replace({
        path: "/sign",
        query: {
          meetingId,
          init: true
        }
      });
    }
    this.meetingId = meetingId;
    this.getMeetingData();
  },
  mounted() {
    history.pushState(null, null, document.URL);
    let _this = this;
    window.addEventListener(
      "popstate",
      function (e) {
        try {
          _this.$router.replace({
            path: "/sign",
            query: {
              meetingId,
              init: true
            }
          });
        } catch (e) { }
      },
      false
    );
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style>
.mobileModal {
  width: calc(100vw - 50px);
}

.meeting-sign {
  background-color: #f9f9f9;
  height: 100vh;
  position: relative;
  padding-bottom: 4vh;
  box-sizing: border-box;
}

.meeting-header {
  background-color: #b6242b;
  color: #ffffff;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  position: relative;
}

.arrow-left {
  position: absolute;
  cursor: pointer;
  left: 10px;
  top: 25px;
  font-size: 44px;
  font-weight: bold;
}

.meeting-body {
  background-color: #ffffff;
  margin-top: 20px;
}

.meeting-body li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  width: calc(100% - 60px);
}

.meeting-name {
  align-items: flex-start !important;
}

.meeting-name span:last-child {
  flex-basis: 70%;
}

.meeting-intro {
  align-items: flex-start !important;
}

.meeting-intro span:last-child {
  width: 70%;
}

.meeting-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  text-align: center;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 2vh;
  padding-top: 1vh;
  box-shadow: 0 -1px 0 #efefef;
}

.next-btn {
  width: 100%;
}

.tips {
  height: 12px;
  font-size: 5px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.sign-header {
  height: 20px;
  padding: 0 20px;
  line-height: 20px;
  background-color: rgba(243, 243, 243, 0.6);
}

.sign-row {
  padding: 15px 0;
}

.no-scroll {
  overflow: hidden;
}

.meeting-title {
  height: 40px;
  line-height: 40px;
  background-color: transparent;
  color: #333333;
  font-size: 14px;
}

.bgColor {
  background-color: #ffffff;
  overflow-x: hidden;
}

.dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  color: #ffffff;
  text-align: center;
  padding: 30px 0;
}

.dialog p {
  margin: 0px;
}

.dialog .success-icon {
  font-size: 80px;
  margin-bottom: 10px;
}

.ver-code {
  display: flex;
}

.code-btn {
  margin-left: 2px;
}

.title {
  width: 200px;
}

.backDiv {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-box {
  width: 540px;
  display: flex;
  flex-direction: column;
  align-items: center;

  background: #ffffff;
  border-radius: 16px;
  background: rgba(255, 255, 255, 1);
  font-size: 30px;
}

.dialog-box_title {
  font-size: 32px;
  color: #000000;
  text-align: center;
  margin-top: 56px;
}

.dialog-box_content {
  width: 460px;
  font-size: 28px;
  color: #333333;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 56px;
}

.dialog-box_Btn {
  width: 100%;
  height: 95px;
  border-radius: 0 0 16px 16px;
  font-size: 30px;
  color: #b6242b;
  text-align: center;
  background: #fff;
  line-height: 95px;
  box-shadow: 0 -1px 0 #eee;
}

.flexS {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/signPage.vue